export const CHART_TITLE = "Energy Delivered & Sessions";

export const ENERGY_BAR_COLOR = "#2563eb";
export const SESSIONS_BAR_COLOR = "#f97316";
export const GRID_STROKE = "#f0f0f0";
export const TOOLTIP_BORDER = "1px solid #e5e7eb";
export const BAR_RADIUS = [4, 4, 0, 0];
export const BAR_SIZE = 24;
export const CHART_HEIGHT = 320;

// Generate 15 days of mock data with proper dates
export const MOCK_ENERGY_TREND = [
  { date: "Mar 27", energy: 580, sessions: 142 },
  { date: "Mar 28", energy: 620, sessions: 156 },
  { date: "Mar 29", energy: 710, sessions: 178 },
  { date: "Mar 30", energy: 680, sessions: 165 },
  { date: "Mar 31", energy: 740, sessions: 190 },
  { date: "Apr 1", energy: 830, sessions: 212 },
  { date: "Apr 2", energy: 560, sessions: 140 },
  { date: "Apr 3", energy: 490, sessions: 122 },
  { date: "Apr 4", energy: 720, sessions: 180 },
  { date: "Apr 5", energy: 690, sessions: 168 },
  { date: "Apr 6", energy: 750, sessions: 195 },
  { date: "Apr 7", energy: 810, sessions: 205 },
  { date: "Apr 8", energy: 640, sessions: 158 },
  { date: "Apr 9", energy: 700, sessions: 175 },
  { date: "Apr 10", energy: 780, sessions: 198 },
];
